import styled from "styled-components";
import ParagraphSup from "../../../atom/text/paragraph_sup";
import {ConstBreakPoint} from "../../../../../config/styles_const/styles_const";
import BtnLinkCorporateMiddle from "../../../atom/btn/btn_link_corporate_middle";
import Paragraph from "../../../atom/text/paragraph";

export const Title = styled(Paragraph)`
    margin-bottom: 20px;
`;

export const Ul = styled.ul`
    margin-bottom: 50px;
    padding: 0;
    list-style: none;
    @media screen and (min-width: ${ConstBreakPoint.Default}) {
        margin-bottom: 0;
    }
`;

export const Li = styled.li`
    margin-bottom: 10px;
`;

export const LiberaInc = styled(ParagraphSup)`
    text-align: end;
`;

export const ButtonLinkWrapper = styled.div`
    margin-bottom: 40px;
    @media screen and (min-width: ${ConstBreakPoint.Default}) {
        margin-bottom: 0;
        display: flex;
        height: 100%;
    }
`;

export const ButtonLink = styled(BtnLinkCorporateMiddle)`
    width: 150px;
    margin-left: 20px;
    text-align: center;
`;


// WEBPACK FOOTER //
// ./src/presentation/common/organism/footer/share/footer_components.tsx